<template>
  <div class="content">
    <div class="left">{{title}}</div>
    <div class="right" @click="isShowContact = !isShowContact">
      <img src="@/assets/img/open/icon_wechat.png" alt="">
      <div class="font">联系客服</div>
      
      <div class="position">
        <Contact v-show="isShowContact"></Contact>
      </div>
    </div>
    

  </div>
</template>

<script>
import Contact from '@/components/Contact'

export default {
  name: '',
  components: {Contact},
  props: ['title'],
  data() {
    return {
      isShowContact:false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {}
}
</script>
<style lang='less' scoped>
.content {
  display: flex;
  justify-content: space-between;

  .left {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
  }
  .right {
    display: flex;
    justify-content: end;
    align-items: center;
    // width: 100%;
    cursor: pointer;
    // justify-content: space-between;
    position: relative;

    .font {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
    }
    img {
      width: 24px;
      height: 24px;
    }
    .position {
      position: absolute;
      right: 200px;
      top: -41px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/components/title.vue